import React from 'react';
import Slider from 'react-slick';
import css from './Sections.module.css';
import '../../../styles/slick/slick.css';
import '../../../styles/slick/slick-theme.css';
import { isArrayLength } from '../../../util/genericHelpers';

function Step({ video }) {
  return (
    <div className={css.talentBlock}>
      <div className={css.talentBlockImg}>
        <video autoPlay loop muted playsInline src={video?.fileLink} />
      </div>
    </div>
  );
}

function TalentPlusServices(props) {
  const { intl, isMobileLayout, publicData } = props;

  const { profileVideos = [] } = publicData || {};
  // If no steps are available after filtering, return null to avoid rendering the section
  if (!isArrayLength(profileVideos)) {
    return null;
  }
  const { formatMessage } = intl;
  return (
    <div className={css.howItWorks}>
      <div className={css.contentWidth}>
        <div className={css.sectionHead}>
          <div className={css.leftSec}>
            <h2>
              {formatMessage({
                id: 'TalentPlusServices.heading',
              })}
            </h2>
          </div>
        </div>
        <div className={css.contentHeroTabs}>
          <div className={css.tabs}>
            <span className={css.active}>
              {formatMessage({
                id: 'TalentPlusServices.talentVideos',
              })}
            </span>
            {/* <span>
              {formatMessage({
                id: 'TalentPlusServices.socialMediaFeeds',
              })}
            </span> */}
          </div>
        </div>
        <div className={css.sectionContent}>
          <div className={css.featuredListingsContent}>
            <div className={css.templatesSlider}>
              {isArrayLength(profileVideos) ? (
                <Slider {...{ ...sliderSettings, arrows: false }}>
                  {profileVideos.map((video, index) => (
                    <Step key={video.key} video={video} />
                  ))}
                </Slider>
              ) : (
                <div className={css.noContent}>
                  {formatMessage({
                    id: 'TalentPlusServices.noContent',
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Default slider settings
const sliderSettings = {
  dots: false,
  arrows: true,
  infinite: true,
  autoplay: false,
  autoplaySpeed: 2000,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  variableWidth: false,
  focusOnSelect: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 2,
        variableWidth: false,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        variableWidth: false,
      },
    },
    {
      breakpoint: 767,
      settings: {
        centerMode: true,
        slidesToShow: 1,
        variableWidth: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        centerMode: true,
        slidesToShow: 1,
        variableWidth: false,
      },
    },
  ],
};

export default TalentPlusServices;
